module.exports = __webpack_public_path__ + "static/img/manual4.ec271b27.png";